import React from 'react';
import styles from "./FeedbackAndSupport.module.scss";
import { useNavigate } from 'react-router-dom';
import DynamicTableFilters from '../../../common/AdminCommonComponents/DynamicTableFilters/DynamicTableFilters';
import DynamicDatatable from '../../../common/AdminCommonComponents/DynamicDatatable/DynamicDatatable';
import StatusBadge from '../../../common/AdminCommonComponents/StatusBadge/StatusBadge';
import ActionButton from '../../../common/AdminCommonComponents/Buttons/ActionButton/ActionButton';
import { feedbackTableData, supportTickerTableData } from '../../../../views/AdminPortal/dummyData';
import ActionBtn from '../../../common/AdminCommonComponents/Buttons/ActionButton/ActionBtn';

function FeedbackAndSuggestionsComp({setActive}) {
    const navigate = useNavigate();
    const ampleOptions = [
        { label: "View Info", action: () => onClick() },
        { label: "Edit", action: () => console.log("Activate Product") },
        { label: "Delete", action: () => console.log("Notify Seller") },
        { label: "Change Status", action: () => console.log("Notify Seller") },
    ];

    const columns = [
        {
            name: "Sr.",
            selector: (_, index) => index + 1,
            center: "true",
            width: "80px",
        },
        {
            name: "ID",
            selector: (row) => row.id,
            center: "true",
            width: "150px",
        },
        {
            name: "User Name",
            selector: (row) => row.userName,
            center: "true",
        },
        {
            name: "Rating",
            selector: (row) => row.rating,
            center: "true",
        },
        {
            name: "Type",
            selector: (row) => row.type,
            center: "true",
        },
        {
            name: "Subject",
            selector: (row) => row.subject,
            center: "true",
        },
        {
            name: "Date Submitted",
            selector: (row) => row.dateSubmitted,
            center: "true",
        },
        {
            name: "Actions",
            cell: (row) => <ActionBtn onClick={() => {
                if (row.actions === "View") {
                    setActive()
                }
            }} statusName={row.actions} />,
            center: "true",
        },
    ];

    const handleApply = (filters) => {
        console.log("Applied Filters:", filters);
    };

    const handleClear = () => {
        console.log("Filters Cleared");
    };

    return (
        <div>
            <DynamicTableFilters apply={false} componentName={"Support Tickets"} onClear={handleClear} />
            <div className={styles.tableWrapper}>
                <DynamicDatatable
                    data={feedbackTableData}
                    columns={columns}
                    type="gray"
                    pagination
                    highlightOnHover
                    responsive
                />
            </div>
        </div>
    );
};

export default FeedbackAndSuggestionsComp
